import { Calendar } from '../../shared/components/Calendar/Calendar';
import { Tooltip } from '../../tooltip/Tooltip';

export function UsageSummaryDuration({
  label,
  startTime,
  endTime
}: {
  label: string;
  startTime?: number;
  endTime?: number;
}) {
  return (
    <Tooltip
      dataId=''
      title={
        startTime && endTime ? <DurationTooltip startTime={startTime} endTime={endTime} /> : null
      }
    >
      <span>{label}</span>
    </Tooltip>
  );
}

function DurationTooltip({ startTime, endTime }: { startTime: number; endTime: number }) {
  return (
    <>
      <Calendar value={startTime} /> - <Calendar value={endTime} />
    </>
  );
}
